var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreInfo({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.8685C13.0264 13.8685 13.8588 13.0362 13.8588 12.0095C13.8588 10.9827 13.0264 10.1504 11.9997 10.1504C10.973 10.1504 10.1406 10.9827 10.1406 12.0095C10.1406 13.0362 10.973 13.8685 11.9997 13.8685Z",
    fill: "#AFBCC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5778 13.8685C18.6045 13.8685 19.4369 13.0362 19.4369 12.0095C19.4369 10.9827 18.6045 10.1504 17.5778 10.1504C16.5511 10.1504 15.7188 10.9827 15.7188 12.0095C15.7188 13.0362 16.5511 13.8685 17.5778 13.8685Z",
    fill: "#AFBCC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42156 13.8685C7.44829 13.8685 8.28062 13.0362 8.28062 12.0095C8.28062 10.9827 7.44829 10.1504 6.42156 10.1504C5.39483 10.1504 4.5625 10.9827 4.5625 12.0095C4.5625 13.0362 5.39483 13.8685 6.42156 13.8685Z",
    fill: "#AFBCC4"
  })));
}

export default SvgMoreInfo;